import { emptyLanguageEntry } from '../constants/languageProficiency';

export function normalizeLanguagesKnown(source) {
  const list = Array.isArray(source) ? source : [];
  const seen = new Set();
  const out = [];

  for (const row of list) {
    const language = String(row?.language || '').trim();
    if (!language || seen.has(language.toLowerCase())) continue;
    seen.add(language.toLowerCase());
    out.push({
      language,
      read: !!row.read,
      write: !!row.write,
      speak: !!row.speak,
      readLevel: row.read ? String(row.readLevel || '').trim() : '',
      writeLevel: row.write ? String(row.writeLevel || '').trim() : '',
      speakLevel: row.speak ? String(row.speakLevel || '').trim() : ''
    });
  }
  return out;
}

export function normalizeLanguagesFromCandidate(candidateOrForm) {
  if (!candidateOrForm) return [];
  return normalizeLanguagesKnown(candidateOrForm.languagesKnown ?? candidateOrForm.languages_known);
}

export function addLanguageEntry(entries, languageName) {
  const language = String(languageName || '').trim();
  if (!language) return entries;
  const norm = normalizeLanguagesKnown(entries);
  if (norm.some(e => e.language.toLowerCase() === language.toLowerCase())) return norm;
  return [...norm, emptyLanguageEntry(language)];
}
